import axios from 'axios';

class AlertService {
    private telegramAlert: any;
    private submitFailsAlert: any;
    private discordAlert: any;

    constructor() {
        this.telegramAlert = {
            url: 'https://api.telegram.org',
            botToken: '7462986831:AAHEqL1e_cam6ElpvKjztl8lAZ2vCau8JWk',
            chatId: '-1002618347850',
        };

        this.submitFailsAlert = {
            url: 'https://api.telegram.org',
            botToken: '7462986831:AAHEqL1e_cam6ElpvKjztl8lAZ2vCau8JWk',
            chatId: '-1002558517531',
        };

        this.discordAlert = {
            webhookUrl: 'https://discord.com/api/webhooks/1393091373900763186/vh1l9UFIvOS0bOeh1aHc424iuyQUCVu6G86ceX8Sxww6TiCt6cQY6aVbsclwfoH3G-00', // Replace with your Discord webhook URL
        };
    }

    async alertTelegram(message: any): Promise<boolean> {
        try {
            const content = encodeURI(
                `\`\`\`json\n${JSON.stringify(message, null, 2)}\n\`\`\``,
            );
            await axios.get(
                `${this.telegramAlert.url}/bot${this.telegramAlert.botToken}/sendMessage?chat_id=${this.telegramAlert.chatId}&text=${content}&parse_mode=Markdown`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );

            return true;
        } catch (ex: any) {
            console.error('alertTelegram ', ex);
            return false;
        }
    }

    async alertTelegramSubmitFail(message: any): Promise<boolean> {
        try {
            const content = encodeURI(
                `\`\`\`json\n${JSON.stringify(message, null, 2)}\n\`\`\``,
            );
            await axios.get(
                `${this.submitFailsAlert.url}/bot${this.submitFailsAlert.botToken}/sendMessage?chat_id=${this.submitFailsAlert.chatId}&text=${content}&parse_mode=Markdown`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );

            return true;
        } catch (ex: any) {
            console.error('alertTelegram ', ex);
            return false;
        }
    }

    async alertDiscord(message: any): Promise<boolean> {
        console.log("alert")
        try {
            const content = {
                content: `\`\`\`json\n${JSON.stringify(message, null, 2)}\n\`\`\``,
            };
            await axios.post(this.discordAlert.webhookUrl, content, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return true;
        } catch (ex: any) {
            console.error('alertDiscord ', ex);
            return false;
        }
    }
}

export const TELE_ALERT = new AlertService();